import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loadAttaches } from '../thunks/attaches.thunk';
import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { chatActions } from './chat';
import { IErrorsState, IGeneralError } from './types';

const initialState: IErrorsState = {
  errors: [],
};

export const errorsSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    addError: (state, action: PayloadAction<IGeneralError>) => {
      return {
        ...state,
        errors: [...state.errors, action.payload],
      };
    },
    removeError: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        errors: [...state.errors.slice(0, action.payload), ...state.errors.slice(action.payload + 1)],
      };
    },
    removeErrorByLocalKey: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        errors: state.errors.filter(({ localKey }) => localKey !== action.payload),
      };
    },
    clearErrors: (state) => {
      return {
        ...state,
        errors: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttaches.rejected, (state, action) => {
      return {
        ...state,
        errors: action.payload ? [...state.errors, action.payload] : state.errors,
      };
    });

    builder.addCase(chatActions.addItem, (state) => {
      return {
        ...state,
        errors: [],
      };
    });

    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      return {
        errors: [],
      };
    });
  },
});
